class AccordionHandler {
    constructor(element) {
      // Store the accordion element (details)
      this.details = element;
      this.summary = this.details.querySelector('summary');
      this.content = this.details.querySelector('.header-drawer__submenu');
      
      this.init();
    }
  
    init() {
      // Remove any existing click events from the summary
      const newSummary = this.summary.cloneNode(true);
      this.summary.parentNode.replaceChild(newSummary, this.summary);
      this.summary = newSummary;
      
      // Add our new event listener
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.details.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      });
      
      // Prevent default details behavior
      this.details.addEventListener('toggle', (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    }
  
    open() {
      // Find all other open accordions in the same container
      const container = this.details.closest('.header-drawer__menu');
      if (container) {
        const otherAccordions = container.querySelectorAll('.js-accordion[open]');
        otherAccordions.forEach(openDetails => {
          if (openDetails !== this.details) {
            const accordionInstance = openDetails.__accordion;
            if (accordionInstance) {
              accordionInstance.close();
            }
          }
        });
      }
  
      // Open this accordion
      this.details.setAttribute('open', '');
      
      // Set initial height for animation
      this.details.style.overflow = 'hidden';
      const startHeight = `${this.summary.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      
      const animation = this.details.animate([
        { height: startHeight },
        { height: endHeight }
      ], {
        duration: 300,
        easing: 'ease-out'
      });
      
      animation.onfinish = () => {
        this.details.style.height = '';
        this.details.style.overflow = '';
      };
    }
  
    close() {
      // Set initial height for animation
      this.details.style.overflow = 'hidden';
      const startHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      
      const animation = this.details.animate([
        { height: startHeight },
        { height: endHeight }
      ], {
        duration: 300,
        easing: 'ease-out'
      });
      
      animation.onfinish = () => {
        this.details.removeAttribute('open');
        this.details.style.height = '';
        this.details.style.overflow = '';
      };
    }
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  // Find all accordion details elements
  const accordionElements = document.querySelectorAll('details.js-accordion');
  
  // Initialize each accordion
  accordionElements.forEach(accordion => {
    accordion.__accordion = new AccordionHandler(accordion);
  });
});